'use client';

import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import { segmentTrackSchema, SegmentTrackSchema } from '../../utils/validation-schemas/segment/track';
import { useSegmentTrack } from '../../hooks/useSegmentTrack';
import defaultBouncerImg from '../../assets/images/training-bouncer-avatar.png';
import { theme } from '../../wag-react/themes/base-theme';
import { TooltipBouncer } from '../../wag-react/components/floating-action-buttons/components/TooltipBouncer';
const defaultBgColor = theme.colors.tuftsBlue;
type Variant = {
  copy: string;
  url: string;
  bgColor?: string;
  bouncerImg?: string;
  experiment?: string;
};
export type Props = {
  contentType: string;
  fixedVariantId?: number;
  variants: Array<Variant>;
};
export const RotatingBouncer = (props: Props) => {
  const {
    executeTrack: executeSegmentTrack
  } = useSegmentTrack();
  const {
    variants,
    fixedVariantId,
    contentType
  } = props;
  const goToCta = () => {
    const experiment = variants[variantIndex].experiment === undefined ? '' : variants[variantIndex].experiment;
    const trackData = segmentTrackSchema.cast({
      event: 'CTA Clicked',
      properties: {
        cta_type: 'bouncer',
        content_type: contentType,
        variant: variants[variantIndex].copy,
        experiment
      }
    } as SegmentTrackSchema);
    executeSegmentTrack({
      data: trackData
    });
    const destURL = queryString.stringifyUrl({
      url: variants[variantIndex].url,
      query: {
        utm_content: contentType
      }
    });
    window.open(destURL, '_blank');
  };
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [variantIndex, setVariantIndex] = useState(0);
  useEffect(() => {
    if (isFirstLoad === false) return;
    let variantId = fixedVariantId;
    if (variantId === undefined) {
      variantId = Math.floor(Math.random() * variants.length);
    }
    setVariantIndex(variantId);
    setIsFirstLoad(false);
  }, [isFirstLoad, variants, fixedVariantId]);
  const bgColor = variants[variantIndex].bgColor === undefined ? defaultBgColor : variants[variantIndex].bgColor;
  const bouncerImg = variants[variantIndex].bouncerImg === undefined ? defaultBouncerImg : variants[variantIndex].bouncerImg;
  const bouncerCopy = variants[variantIndex].copy;
  return <TooltipBouncer avatar={{
    src: bouncerImg,
    containerProps: {
      border: 'none',
      borderRadius: 0
    },
    imageProps: {
      alt: 'Wag! Specialist',
      borderRadius: 0,
      style: {
        cursor: 'pointer'
      }
    }
  }} tooltip={{
    text: bouncerCopy,
    bg: bgColor,
    px: '16px',
    py: '16px',
    fontSize: '20px',
    fontWeight: 'normal',
    width: '242px'
  }} onClick={goToCta} data-sentry-element="TooltipBouncer" data-sentry-component="RotatingBouncer" data-sentry-source-file="index.tsx" />;
};